import './App.css';
import logo from './assets/images/logo.png';
import ArrowIcon from './assets/images/ArrowIcon';

function App() {
  return (
    <div className="App">
      <div className="App-content">
        <div className="image-bg"></div>
        <div className="App-header">
          <img className="App-header-image" src={logo} />
        </div>
        <div className="Main-title_wrapper">
          <div className="Main-title">
            <p>THE AIRWAYS</p>
            <p>AWAIT YOU</p>
          </div>
        </div>
        <div className="Description-section">
          <div className="Description-left">
            <p className="Description-left_title">
              <span className="white-bold">
                The Airport Solution for Quality Control and Compliance
              </span>
            </p>
            <p className="Description-left_text">
              <span className="white-bold">AIRPORT360,</span> is a cutting-edge
              platform developed by industry professionals to facilitate the
              auditing of airports, airlines, and related organizations.
              Designed for authorities and companies, Airport360 enables the
              systematic recording of audits and the monitoring of compliance
              with both national and international standards.
            </p>
            <p className="Description-left_text">
              This robust auditing tool offers the flexibility to create
              customized assessments and audits, ensuring thorough regulatory
              oversight and adherence to key standards. With Airport360, users
              can efficiently track corrective actions and maintain high levels
              of operational compliance, enhancing safety and performance across
              the aviation industry
            </p>
            <ArrowIcon />
          </div>
          <div className="Description-right">
            <p className="Description-right_title">Prepare Custom Audits</p>
            <p className="Description-right_text">
              Select which categories, sub-categories, and questions to include
              in each Airport, and assign it to a specific Airport. This allows
              you to:
            </p>
            <ul className="Description-right_list">
              <li>Create targeted inspections.</li>
              <li>Monitor and report on specific aspects.</li>
              <li>
                Update audit question bank in responseto regulatory changes.
              </li>
            </ul>
            <ArrowIcon color="#EB175E" />
          </div>
        </div>
      </div>
      <footer className="App-footer">
        <p>© 2024 AIRPORT360</p>
        <p>powered by CULMEN</p>
      </footer>
    </div>
  );
}

export default App;
